var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirlMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1133.9 1133.9",
    style: {
      enableBackground: "new 0 0 1133.9 1133.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#141125;}\n\t.st1{fill:#E8DBCF;}\n\t.st2{fill:#EE7657;}\n\t.st3{fill:#E84222;}\n\t.st4{fill:#F7B710;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#293044;}\n\t.st7{fill:#94C7D4;}\n\t.st8{fill:#F7EAE1;}\n\t.st9{fill:#F9EEE7;}\n\t.st10{fill:#313336;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2846",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19124",
    className: "st0",
    d: "M558.8,487.7L558.8,487.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.5,0.8-11.9,1.8-14.3 c0.1-0.2,0.4-0.3,0.5-0.1c0.2,0.1,0.2,0.3,0.2,0.4c-0.9,2.3-1.7,13.9-1.7,14C559.2,487.5,559,487.7,558.8,487.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19150",
    className: "st0",
    d: "M480.9,698.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.2c0.1-0.1,9.9-13,12.7-20.2 c0.1-0.2,0.3-0.3,0.5-0.3c0.2,0.1,0.3,0.3,0.3,0.5v0.1c-2.8,7.3-12.4,19.9-12.8,20.4C481.1,698,481,698.1,480.9,698.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19152",
    className: "st1",
    d: "M536.8,531.9c1.7,5.7,9.7,12.5,13.7,15.1c2.8,1.7,5.8,3.1,9,4c0,0,0.7,7.8,3.8,8.7 s5.2-2.4,5.2-2.4s1,0.4,3.5-1s3.5-5,3.5-5c2.2-1.4,3.9-3.5,4.7-6c1.4-4.3-0.6-11.5-3-14.6s-10.4-7.6-10.4-7.6l4-4.2 c0,0-8.7-4.3-11.4-5.9c-2.7-1.6-23.1-29.8-23.1-29.8l18.2,3.8l0.5-9.1l-28.1-7.1l-5.7,35.5L536.8,531.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19153",
    className: "st2",
    d: "M575.5,551.7c-0.2,0-0.4-0.2-0.4-0.4v-0.1c2.7-10.6-6.4-17.1-7.4-17.8 c-0.2-0.1-0.3-0.3-0.2-0.5s0.3-0.3,0.5-0.2c0,0,0.1,0,0.1,0.1c1.1,0.7,10.6,7.6,7.8,18.7C575.8,551.6,575.7,551.7,575.5,551.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19154",
    className: "st2",
    d: "M568.5,557.8C568.5,557.8,568.4,557.8,568.5,557.8c-0.3-0.1-0.4-0.3-0.4-0.5 c1.9-7.8-3.4-14.1-7.2-16.2c-0.2-0.1-0.3-0.3-0.2-0.5s0.3-0.3,0.5-0.2c0,0,0.1,0,0.1,0.1c4,2.2,9.6,8.8,7.6,17.1 C568.8,557.7,568.7,557.8,568.5,557.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19155",
    className: "st2",
    d: "M565.3,559.9c-0.2,0-0.3-0.1-0.4-0.3c-0.3-1.6-0.2-3.3,0.4-4.9c0.3-1,1.2-3.3,2.8-3.9 c0.2-0.1,0.4,0,0.5,0.2s0,0.4-0.2,0.5h-0.1c-1.9,0.7-3.3,5.7-2.7,7.8c0.1,0.2-0.1,0.4-0.3,0.5 C565.3,559.9,565.3,559.9,565.3,559.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19156",
    className: "st2",
    d: "M570.1,557.2L570.1,557.2c-0.3,0-0.4-0.2-0.4-0.4c0.2-2.3,2.7-5.9,5.7-7.3 c0.2-0.1,0.4-0.1,0.6,0.1c0.1,0.2,0.1,0.4-0.1,0.6h-0.1c-2.2,1-5.1,4.2-5.3,6.6C570.4,557,570.3,557.2,570.1,557.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19157",
    className: "st2",
    d: "M566.9,523.5c-0.1,0-0.2,0-0.2-0.1c-1.9-1.3-3.6-2.6-3.6-2.6c-0.2-0.2-0.2-0.4,0-0.6 c0.1-0.1,0.3-0.2,0.5-0.1c0,0,1.8,1.3,3.6,2.6c0.2,0.1,0.2,0.4,0.1,0.6C567.1,523.5,567,523.5,566.9,523.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19163",
    className: "st3",
    d: "M476.8,740.1c0,0,2.7,7.1,3.3,11.3c0.3,2.2,0.5,4.4,0.6,5.9c0.1,1.2-0.9,2.2-2.1,2.3h-0.1 h-64.7c0,0-1.3-3.6,4.4-4.6s22.2-4.1,24.1-5.2s0.5-3.8,0.5-3.8L476.8,740.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19164",
    className: "st4",
    d: "M478.5,759.7c1.2,0,2.2-1,2.2-2.2v-0.1c-0.1-1.5-0.2-3.7-0.6-5.9c0-0.3-0.1-0.5-0.1-0.8 c-6.7,1-23.5,5.8-27.2,6.1c-3.9,0.3-30.2,0.5-38.6,0.5c-0.5,0.7-0.6,1.6-0.3,2.4H478.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19165",
    className: "st5",
    d: "M435,755.6c-0.2,0-0.4-0.1-0.4-0.3c-0.1-1-0.4-1.9-0.9-2.8c-0.1-0.2,0-0.4,0.2-0.5 s0.4,0,0.5,0.1c0.5,1,0.9,2,1,3.1C435.5,755.4,435.3,755.6,435,755.6C435.1,755.6,435.1,755.6,435,755.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19166",
    className: "st5",
    d: "M440.4,754.9c-0.2,0-0.3-0.1-0.4-0.3c-0.4-1-0.9-2-1.4-3c-0.1-0.2-0.1-0.4,0.1-0.6 s0.4-0.1,0.6,0.1c0,0,0,0.1,0.1,0.1c0.5,1,1,2.1,1.4,3.1c0.1,0.2-0.1,0.4-0.3,0.5C440.4,754.9,440.4,754.9,440.4,754.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19167",
    className: "st5",
    d: "M445.9,754.1c-0.1,0-0.2-0.1-0.3-0.2c0,0-2.1-2.9-3.5-3.7c-0.2-0.1-0.2-0.4-0.1-0.6 c0.1-0.1,0.3-0.2,0.5-0.1c1.6,0.9,3.7,3.8,3.8,3.9c0.1,0.2,0.1,0.4-0.1,0.6C446.1,754,446,754.1,445.9,754.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19168",
    className: "st5",
    d: "M451.9,751.8c-0.1,0-0.2,0-0.3-0.1c-1.9-1.6-3.9-2.9-6.1-4.1c-0.2,0-0.4-0.2-0.3-0.5 c0-0.2,0.2-0.4,0.5-0.3h0.1c1.3,0.4,5.5,3.4,6.4,4.2c0.2,0.1,0.2,0.4,0,0.6C452.1,751.8,452,751.8,451.9,751.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19169",
    className: "st6",
    d: "M462.6,754.7L462.6,754.7c-0.2,0-0.4-0.2-0.4-0.4c0.1-2.8,3.4-10.2,9.3-14.2 c0.2-0.2,0.4-0.1,0.6,0c0.2,0.2,0.1,0.4,0,0.6c0,0-0.1,0-0.1,0.1c-5.6,3.9-8.8,11-8.9,13.6C462.9,754.5,462.8,754.7,462.6,754.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19170",
    className: "st3",
    d: "M581.6,751.5c-0.9-8.4-6.3-18.5-6.3-18.5l-26.8,8c0,0,0.5,6.6-4.7,9 c-1.9,1.1-18.4,4.3-24.1,5.2s-4.4,4.6-4.4,4.6H580c1.2,0,2.2-1,2.2-2.2v-0.1C582.1,755.8,581.9,753.7,581.6,751.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19171",
    className: "st4",
    d: "M580,759.7c1.2,0,2.2-1,2.2-2.2v-0.1c-0.1-1.5-0.2-3.7-0.6-5.9c0-0.3-0.1-0.5-0.1-0.8 c-6.7,1-20.6,4.8-27.3,5.5c-5.7,0.6-30,1-38.5,1.1c-0.5,0.7-0.6,1.6-0.3,2.4H580z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19172",
    className: "st6",
    d: "M500.7,434.4c-14,2.5-27.2,5-34.2,9.7s-31.2,35.4-31.2,35.4l24.1,23.9l17.2-21l1.4,16.5 l50.5-5.7l0.7-19.4l28.1,6.4l11.3-37c-10.9-3.3-22-5.7-33.3-7.4C519.4,433.6,505.9,433.4,500.7,434.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19173",
    className: "st0",
    d: "M502.2,454.2h-0.1c-1.8-0.2-5.5-5-7.5-7.8c-2.1-2.9-5.3-7.7-5.2-8.8 c0-0.2,0.3-0.4,0.5-0.3c0.2,0,0.3,0.2,0.3,0.4c0,0.5,1.9,4,5.1,8.3c3.2,4.4,5.9,7.3,7,7.4c0.3,0,1.9-0.4,7.1-7.5 c2.8-3.9,5.4-7.9,5.4-7.9c0.1-0.2,0.4-0.2,0.6,0c0.1,0.1,0.2,0.3,0.1,0.5c0,0-2.6,4-5.4,7.9C504.9,453.2,503.1,454.2,502.2,454.2 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19174",
    className: "st7",
    d: "M542.5,637.5c0,0,0.2-36.4,0-57.6s-3.4-77-4.2-80.9c-1.3-6.2-5-11.6-5.5-12.8 c-0.3-0.8-4.7-2-7.6-2.6c-1.7-6.7-3.9-20.8-4.5-49.2c-2.5-0.2-4.9-0.3-7.1-0.4c0.1,6.6,0.4,14.9,1,23.3l-27.7,2.6 c-0.8-9.8-1.4-19-1.4-22.4c-2.5,0.5-4.8,1.1-7,1.8c0.2,5.6,1,17.2,1.9,28.2l0.7,20.2l-7.1,2.8c0,0-5,16.5-10.7,28.1 c-5.7,11.6-25,35.2-34.2,54.3s-22,42-14.2,88.1s24.8,88.6,24.8,88.6s8.3-1.2,20.3-3.5s21-4.7,21-4.7l-20.6-107.7l24.3-48.9 c-2.8,31.9,7.3,71.1,18,96.8c10.6,25.7,38,66.1,38,66.1s9.8-2.5,17.2-5.1c8.5-3,24.3-9.8,24.3-9.8L542.5,637.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19175",
    className: "st8",
    d: "M430.8,413.9c2.8-1.3,6.1-0.3,7.9,2.2l-0.3-0.5c0,0,1.3-3.9,4.7-4.7 c3.5-0.8,4.9,1.6,4.9,1.6c1.3-1.7,3.2-2.8,5.4-3c3.6-0.3,5.7,5.4,5.7,5.4l4.9,10.9c-0.2,6.2-0.8,12.4-1.9,18.6 c-1.6,8-9,27.7-19.2,41.1l13.9,15.1c0,0-16.4,23.1-27.4,29.3s-22.7,5.2-32.3-3.9c-9.6-9.1-7.6-23.6,1.3-35.3s31.6-40.8,31.6-40.8 c-2.1-5.1-3.7-10.4-4.7-15.9C424,426.5,424.5,416.4,430.8,413.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19176",
    className: "st9",
    d: "M522,403.3c2.2-2.2,6.6-1.9,7.2,2s-2.8,9.6-7.2,8.7S522,403.3,522,403.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19177",
    className: "st2",
    d: "M522.6,411.4c-0.2,0-0.4-0.2-0.4-0.4v-0.1c0.9-2.2,1.9-4.3,3-6.4c0.2-0.2,0.4-0.2,0.6,0 c0.1,0.1,0.2,0.3,0.1,0.5c-1.1,2-2.1,4.1-2.9,6.2C522.9,411.3,522.8,411.4,522.6,411.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19178",
    className: "st9",
    d: "M493.5,432c0,0,0.3,4.6-1.3,5.4c2.7,4.9,6,9.3,10,13.1c0,0,3-3.1,6.1-7.1 c2.1-2.5,3.7-5.4,4.9-8.4c-1-1.9-1.8-3.9-2.4-6L493.5,432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19179",
    className: "st3",
    d: "M479.2,390.5c0.6-3.3,3.8-8.7,9.7-11.3c6.9-3.1,12.6-0.5,15.9-0.5s4.2-2.5,3.6-4.5 c-0.5-2-1.4-7.7,1.9-9.3c2.5-1.2,5.5-0.3,6.9,2.1c0.7,1.4,3.4,1.4,3.2-0.3c-0.2-1.7-0.2-10.4,6.1-12.1s8.6,3.3,9.3,4.8 s3.3,0.8,4.2-1s5.7-5.5,11.8-4.4s7.4,5,7.6,7.3c0.3,3.3-2.8,5.7-2.5,6.8c0.7,2.2,7.9,2.7,7.8,7.4c0,3.6-2.7,6.6-6.3,6.9 c-2.2,0.2-3.8-0.4-4.5,0.8c-0.7,1.1,4.2,3.6,2.7,8.8c-0.8,3.7-4.6,6.1-8.3,5.2c-0.4-0.1-0.8-0.2-1.1-0.4c-2.5-1-3.2-3.7-4.5-3.3 c-1.2,0.4-0.6,6.3-6.5,6.3s-7.3-5.1-7.8-6.7s-2.4-0.5-3.1,1.2c-0.6,1.7-3.5,5.4-7.2,4.9C514.4,398.8,479.2,390.5,479.2,390.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19180",
    className: "st1",
    d: "M516.3,408.4c0,10.1-8.2,18.3-18.3,18.3c-10.1,0-18.3-8.2-18.3-18.3 c0-10.1,8.2-18.3,18.3-18.3C508.1,390.1,516.3,398.3,516.3,408.4L516.3,408.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19181",
    className: "st5",
    d: "M481.8,409.6c-0.3-1.6,8.4-10.2,18.3-10.5c9.6-0.3,17.2,5.7,17.5,8s-8,8.5-17.8,8.4 C489.5,415.3,482.2,411.7,481.8,409.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19182",
    className: "st10",
    d: "M499.7,414c-3,0-4.6-2.3-4.6-6.7s1.5-6.7,4.6-6.7s4.6,2.3,4.6,6.7S502.7,414,499.7,414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19183",
    className: "st6",
    d: "M486.2,403c-0.1,0-0.2,0-0.3-0.1l-2.5-2.1c-0.2-0.1-0.2-0.4-0.1-0.6s0.4-0.2,0.6-0.1 c0,0,0.1,0,0.1,0.1l2.5,2.1c0.2,0.1,0.2,0.4,0,0.6C486.4,403,486.3,403,486.2,403"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19184",
    className: "st6",
    d: "M491.3,399.6c-0.1,0-0.3-0.1-0.3-0.2l-1.9-3.5c-0.1-0.2-0.1-0.4,0.1-0.6 c0.2-0.1,0.4-0.1,0.6,0.1c0,0,0,0.1,0.1,0.1l1.9,3.5c0.1,0.2,0,0.4-0.2,0.5C491.5,399.5,491.4,399.6,491.3,399.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19185",
    className: "st6",
    d: "M497.5,398.1c-0.2,0-0.4-0.1-0.4-0.3l-0.9-4.8c-0.1-0.2,0-0.4,0.3-0.5 c0.2-0.1,0.4,0,0.5,0.3v0.1l0.9,4.8C497.9,397.8,497.8,398,497.5,398.1L497.5,398.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19186",
    className: "st6",
    d: "M504.1,398.1C504.1,398.1,504,398.1,504.1,398.1c-0.3-0.1-0.4-0.3-0.4-0.5l1.3-4.7 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v0.1l-1.3,4.7C504.4,398,504.3,398.1,504.1,398.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19187",
    className: "st6",
    d: "M485.2,418.4c-0.2,0-0.4-0.2-0.4-0.4v-0.1l1.1-2.8c0.1-0.2,0.4-0.3,0.5-0.1 c0.2,0.1,0.2,0.3,0.2,0.4l-1.1,2.8C485.5,418.3,485.4,418.4,485.2,418.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19188",
    className: "st6",
    d: "M492.2,421.3c-0.2,0-0.4-0.2-0.4-0.4v-0.1l0.9-3.9c0-0.2,0.2-0.4,0.4-0.4 c0.2,0,0.4,0.2,0.4,0.4v0.1l-0.9,3.9C492.6,421.2,492.4,421.3,492.2,421.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19189",
    className: "st6",
    d: "M502,421.7c-0.2,0-0.4-0.2-0.4-0.4l-0.2-4.1c0-0.2,0.1-0.4,0.3-0.5s0.4,0.1,0.5,0.3v0.1 l0.2,4.1C502.4,421.5,502.2,421.7,502,421.7L502,421.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19190",
    className: "st6",
    d: "M511.4,418.6c-0.2,0-0.3-0.1-0.4-0.3l-1.1-2.8c0-0.2,0.1-0.4,0.3-0.5c0.2,0,0.4,0,0.4,0.2 l1.1,2.8C511.8,418.2,511.7,418.4,511.4,418.6C511.5,418.6,511.5,418.6,511.4,418.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19191",
    className: "st6",
    d: "M511.1,400.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.1,0-0.2l1.6-3.4c0.1-0.2,0.4-0.2,0.6-0.1 c0.1,0.1,0.2,0.3,0.2,0.5l-1.6,3.4C511.4,400.4,511.3,400.5,511.1,400.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19192",
    className: "st4",
    d: "M516.3,408.4c0,10.1-8.2,18.3-18.3,18.3c-10.1,0-18.3-8.2-18.3-18.3 c0-10.1,8.2-18.3,18.3-18.3C508.1,390.1,516.3,398.3,516.3,408.4L516.3,408.4 M498,382.7c-14.2,0-25.7,11.5-25.7,25.7l0,0 c0,0.9,0,1.7,0.1,2.6l-53.7,15c-4,1.3,1.6,18.1,5.6,16.8l52.1-20.5c7.7,11.9,23.6,15.3,35.5,7.6c11.9-7.7,15.3-23.6,7.6-35.5 C514.8,387.1,506.7,382.7,498,382.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19193",
    className: "st6",
    d: "M498.3,430.7c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5 S510.7,430.7,498.3,430.7 M498.3,386.4c-12,0-21.7,9.7-21.7,21.7s9.7,21.7,21.7,21.7s21.7-9.7,21.7-21.7l0,0 C520,396.2,510.3,386.5,498.3,386.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19194",
    className: "st8",
    d: "M429.8,421.6c0,0,0,6.6,1.3,9s3.1,3.5,5,3.1s3.8-3.3,4-6.4c0,0,0,5.3,3.2,5.4 s4.3-1.4,4.3-1.4c0.7,1,1.9,1.6,3.1,1.6c2.3,0.2,11.3,9.4,11.3,9.4s2.5-11.3,2.7-15c0.2-3.8,0.7-10.9-1.6-11.7 c-1.3-0.4-2.8-0.4-4.1,0.1c0,0,0.6,0.3-0.1-0.9S429.8,421.6,429.8,421.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19195",
    className: "st2",
    d: "M438,448.7c-0.2,0-0.4-0.2-0.4-0.4c-0.1-7.7,4.9-10.8,7.6-12.5l0,0c2.5-1.5,6.9-5,7.7-5.7 c0-0.4,0.2-1.8,0.7-5.9c0.7-5.5,3.2-8.2,5.2-8.9c0.2-0.1,0.4,0,0.5,0.2s0,0.4-0.2,0.5H459c-1.8,0.6-4.1,3.2-4.7,8.3 c-0.6,5.3-0.7,6-0.7,6c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.2-5.2,4.1-8,5.8l0,0c-2.8,1.7-7.4,4.6-7.3,11.8 C438.4,448.5,438.2,448.7,438,448.7L438,448.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19196",
    className: "st2",
    d: "M440.1,427.7C440.1,427.7,440,427.7,440.1,427.7c-0.3,0-0.4-0.3-0.4-0.5 c0.6-3.6,0.1-9.1-1.7-11.4c-0.1-0.2,0-0.4,0.2-0.5s0.3-0.1,0.5,0.1c2,2.6,2.5,8.2,1.8,12C440.4,427.6,440.3,427.7,440.1,427.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19197",
    className: "st2",
    d: "M429.7,423.5c-0.2,0-0.4-0.2-0.4-0.4c0.1-2.4,0.3-4.8,0.8-7.2c0-0.2,0.2-0.4,0.4-0.4 c0.2,0,0.4,0.2,0.4,0.4v0.1c-0.4,2.3-0.7,4.7-0.8,7.1C430.1,423.4,429.9,423.5,429.7,423.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19198",
    className: "st2",
    d: "M447.6,431.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.2c1.2-1.6,1.9-5,1.9-9.2 c0-3.9-0.6-7.5-1.5-9.1c-0.1-0.2-0.1-0.4,0.1-0.6c0.2-0.1,0.4-0.1,0.6,0.1c0,0,0,0.1,0.1,0.1c2,3.5,2.5,15.4-0.4,19.3 C447.8,431.6,447.7,431.7,447.6,431.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19199",
    className: "st2",
    d: "M464.6,426.2L464.6,426.2c-2.7,0-5-2.1-5.3-4.8c-0.3-2-0.1-4,0.6-5.9 c0.1-0.2,0.4-0.2,0.5-0.1c0.2,0.1,0.2,0.3,0.2,0.4c-0.6,1.8-0.8,3.7-0.5,5.5c0.2,2.3,2.2,4.1,4.5,4.2c0.2,0,0.4,0.2,0.3,0.5 C464.9,426.1,464.7,426.2,464.6,426.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19200",
    className: "st2",
    d: "M443.3,433.1L443.3,433.1c-0.2,0-0.4-0.2-0.4-0.4c0.1-1.9,0.3-3.8,0.8-5.6 c0.7-2.3,2.5-3.6,5.2-3.6c0.2,0,0.4,0.2,0.3,0.5c0,0.2-0.2,0.3-0.3,0.3c-2.3,0-3.8,1-4.5,3c-0.5,1.8-0.8,3.6-0.8,5.4 C443.7,432.9,443.5,433.1,443.3,433.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19201",
    className: "st2",
    d: "M437.1,433.4c-0.7,0-1.4-0.3-1.9-0.8c-0.7-0.9-1-2.2-0.7-3.3c0.3-2.9,2.8-5,5.7-4.8 c0.2,0,0.4,0.1,0.4,0.4c0,0.2-0.1,0.4-0.4,0.4h-0.1c-2.5-0.2-4.7,1.7-4.9,4.1c-0.3,0.9-0.1,1.9,0.5,2.7c0.4,0.4,0.9,0.6,1.5,0.5 c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.1,0.3-0.3,0.4C437.3,433.4,437.2,433.4,437.1,433.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19202",
    className: "st2",
    d: "M432.2,456c-0.2,0-0.3-0.1-0.4-0.2c0,0-1-2.2-2.4-5.8c0-0.2,0.1-0.4,0.3-0.5 c0.2,0,0.4,0,0.4,0.2c1.4,3.6,2.3,5.8,2.4,5.8C432.6,455.7,432.5,455.9,432.2,456C432.3,456,432.3,456,432.2,456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19203",
    className: "st2",
    d: "M417.1,518.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.3c3.6-4.1,18.8-22.9,25.6-32.6 c0.1-0.2,0.3-0.3,0.5-0.2s0.3,0.3,0.2,0.5c0,0,0,0.1-0.1,0.1c-6.9,9.7-22.1,28.5-25.7,32.6C417.3,518.3,417.2,518.4,417.1,518.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19204",
    className: "st8",
    d: "M568.7,443.2c0,0,21.9,6.8,28.8,9.8s15.9,12.1,13.4,23.5s-6.9,18.7-19.1,26.1 s-33.1,17.6-33.1,17.6c-0.8,1.5-2,2.8-3.3,3.8c-1.2,0.8-2.6,1.1-3.9,0.9c0,0,1.4,4.4-1.7,5.4c-3.1,0.9-9.4,0.5-12.4-0.2 s-4.1-4.6-4.1-7.9c0-0.8,0.1-1.6,0.3-2.4c0.5-2.3,0.2-4.8-0.9-6.9c-0.3-0.6-0.5-1.3-0.6-2c-0.1-1.3,0.1-2.6,0.6-3.9 c0.4-1.2,0.6-2.4,0.4-3.6c-0.3-1.7,0-3.5,0.9-5c1.9-2.5,10.7-2.3,15.9-1.5l27.4-17l-18.9-3.3L568.7,443.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19205",
    className: "st2",
    d: "M577.2,480.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0.1-0.2,0.2-0.3c8.5-5.3,20.3-11.3,24-12.5 c0.2,0,0.4,0.1,0.5,0.3c0,0.2-0.1,0.3-0.2,0.4c-3.6,1.2-15.4,7.2-23.9,12.4C577.4,480.2,577.3,480.2,577.2,480.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19206",
    className: "st2",
    d: "M549.8,525.3c-4.4,0-9.2-0.9-10.6-1.7c-0.2-0.1-0.3-0.3-0.2-0.5s0.3-0.3,0.5-0.2 c0,0,0.1,0,0.1,0.1c1.3,0.7,7.1,1.8,11.9,1.5c0.2,0,0.4,0.2,0.4,0.4s-0.1,0.3-0.3,0.4C551,525.3,550.4,525.3,549.8,525.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19207",
    className: "st2",
    d: "M544.8,531c-0.2,0-0.4-0.2-0.4-0.4v-0.1c0.8-2.1,3.1-3.1,7-3.1c0.2,0,0.4,0.1,0.5,0.3 s-0.1,0.4-0.3,0.5h-0.1c-3.5,0-5.6,0.9-6.2,2.6C545.1,530.8,545,531,544.8,531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19208",
    className: "st6",
    d: "M487.8,486.7c-0.2,0-0.4-0.2-0.4-0.4l-0.2-20c0-0.2,0.2-0.4,0.4-0.4l27.2-2.8 c0.2,0,0.4,0.1,0.4,0.3l2.7,20.2c0,0.2-0.1,0.4-0.3,0.4l0,0c-0.1,0-8.1,0.2-14.7,0.8S488,486.7,487.8,486.7 C487.9,486.7,487.8,486.7,487.8,486.7 M488,466.7l0.2,19.1c1.8-0.3,8.7-1.2,14.5-1.7s12.6-0.8,14.3-0.8l-2.6-19.4L488,466.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19209",
    className: "st6",
    d: "M471.9,497.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.1-0.3,0.3-0.4c12.6-3.9,24-5.4,37.2-6.3 c12.3-0.9,23.4,0.3,26.6,1c0.2,0.1,0.3,0.3,0.2,0.5s-0.2,0.3-0.4,0.3c-3.5-0.7-14.8-1.7-26.3-0.9c-13.2,0.9-24.5,2.3-37,6.2 C472,497.8,471.9,497.8,471.9,497.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19210",
    className: "st6",
    d: "M540.4,537.3L540.4,537.3c-16.6-1.5-14.8-30.1-14.1-42.4c0.1-1.5,0.2-2.7,0.2-3.6 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4c0,0.9-0.1,2.2-0.2,3.7c-0.7,12-2.5,40.1,13.3,41.5c0.2,0,0.4,0.3,0.3,0.5 C540.7,537.1,540.6,537.2,540.4,537.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19211",
    className: "st6",
    d: "M484.6,585L484.6,585c-0.3,0-0.4-0.2-0.4-0.4c1.7-17.4,5.3-40.9,6.9-48.2 c0.1-0.2,0.3-0.3,0.5-0.2s0.3,0.2,0.3,0.4c-1.6,7.3-5.2,30.7-6.8,48.1C485,584.8,484.9,585,484.6,585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19212",
    className: "st6",
    d: "M539.2,680.1L539.2,680.1c-0.3,0-0.4-0.2-0.4-0.4c1.9-14,3-28.1,3.3-42.2 c0-0.2,0.2-0.4,0.4-0.4l0,0c0.2,0,0.4,0.2,0.4,0.4c-0.3,14.2-1.4,28.3-3.3,42.3C539.6,680,539.4,680.1,539.2,680.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19213",
    className: "st6",
    d: "M445.2,666.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.1,0-0.2c0.1-0.2,8.8-19.3,15.1-32.8 c0.1-0.2,0.4-0.2,0.6-0.1c0.1,0.1,0.2,0.3,0.2,0.5c-6.3,13.5-15,32.6-15.1,32.8C445.5,666.6,445.4,666.7,445.2,666.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19214",
    className: "st6",
    d: "M464,582.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.3s12.1-10.7,16.3-14.6 c0.1-0.2,0.4-0.2,0.6-0.1c0.2,0.1,0.2,0.4,0.1,0.6l-0.1,0.1c-4.2,4-16.2,14.5-16.3,14.7C464.2,582.3,464.1,582.4,464,582.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19215",
    className: "st6",
    d: "M466.1,533.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.3s10.2-10.9,12.7-15.3 c0.1-0.2,0.4-0.2,0.6-0.1c0.1,0.1,0.2,0.3,0.1,0.5c-2.6,4.5-12.4,15-12.8,15.4C466.3,533.5,466.2,533.6,466.1,533.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19216",
    className: "st6",
    d: "M510.7,578c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0.1-0.3,0.2-0.3c1.2-0.7,4.1-4.3,6.8-7.8 c3.2-4,6.4-8.1,8.2-9.2c0.2-0.1,0.4,0,0.5,0.2s0,0.4-0.1,0.5c-1.7,1-5,5.3-8,9c-2.9,3.7-5.7,7.2-7,8 C510.8,578,510.7,578,510.7,578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19217",
    className: "st6",
    d: "M523.4,631c-0.2,0-0.3-0.1-0.4-0.3c-0.8-2.4-4.7-6.2-8.4-9.9c-3.7-3.6-7.2-7-7.7-9.1 c0-0.2,0.1-0.4,0.4-0.4c0.2,0,0.3,0.1,0.4,0.3c0.4,1.9,4,5.3,7.4,8.7c3.8,3.7,7.7,7.6,8.6,10.2 C523.8,630.7,523.7,630.9,523.4,631C523.5,631,523.4,631,523.4,631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19218",
    className: "st6",
    d: "M514.9,677.1c-0.2,0-0.4-0.2-0.4-0.4v-0.1c0.3-0.8,6.7-20.4,10-24.9 c0.1-0.2,0.3-0.3,0.5-0.2s0.3,0.3,0.2,0.5c0,0,0,0.1-0.1,0.1c-3.2,4.4-9.8,24.5-9.9,24.7C515.2,677,515,677.1,514.9,677.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19219",
    className: "st6",
    d: "M546.1,711.8C546,711.8,546,711.8,546.1,711.8c-0.3,0-0.4-0.3-0.4-0.5 c1.2-6.3,0.7-23.6,0.7-23.8s0.1-0.4,0.3-0.5s0.4,0.1,0.5,0.3v0.1c0,0.7,0.5,17.6-0.7,23.9C546.4,711.7,546.2,711.8,546.1,711.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19220",
    className: "st6",
    d: "M428.4,672.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.1,0.1-0.2c0.1-0.1,7.8-13,9.4-17.9 c0.1-0.2,0.3-0.3,0.5-0.2s0.2,0.3,0.2,0.4c-1.6,4.9-9.2,17.5-9.5,18C428.7,672,428.6,672.1,428.4,672.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19221",
    className: "st6",
    d: "M448.3,719.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.2c2.8-3.9,9.6-18.7,10.3-22.3 c0.1-0.2,0.3-0.3,0.5-0.2s0.3,0.2,0.3,0.4c-0.7,3.7-7.7,18.6-10.5,22.6C448.5,719.8,448.4,719.8,448.3,719.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19222",
    className: "st6",
    d: "M433.3,618.5c-0.2,0-0.4-0.2-0.4-0.4V618c1.5-4.5,3.2-16.6,3.8-21.2 c0.1-0.5,0.1-0.8,0.2-1.1c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v0.1c0,0.3-0.1,0.7-0.2,1.1c-0.6,4.6-2.4,16.8-3.9,21.4 C433.6,618.4,433.4,618.5,433.3,618.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19223",
    className: "st0",
    d: "M529.3,474.2L529.3,474.2c-0.2,0-0.4-0.2-0.4-0.4c0.3-6.2,1.4-24.9,2.1-30.6 c0.1-0.2,0.3-0.3,0.5-0.3s0.3,0.2,0.3,0.4c-0.7,5.7-1.8,24.4-2.1,30.6C529.7,474,529.5,474.2,529.3,474.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19224",
    className: "st0",
    d: "M476.6,482.7c-0.2,0-0.4-0.2-0.4-0.4c-0.8-10.3-3.6-24-5.7-30.3c0-0.2,0.1-0.4,0.3-0.5 c0.2,0,0.4,0.1,0.4,0.2c2.1,6.3,4.8,20,5.7,30.4C477,482.5,476.9,482.7,476.6,482.7L476.6,482.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19225",
    className: "st0",
    d: "M553.4,479C553.4,479,553.3,479,553.4,479c-0.3,0-0.4-0.3-0.4-0.5c0.9-5.1,9.1-30,11-35.5 c0.1-0.2,0.3-0.3,0.5-0.2c0.2,0.1,0.2,0.3,0.2,0.4c-1.9,5.4-10,30.3-11,35.4C553.7,478.9,553.6,479,553.4,479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19226",
    className: "st0",
    d: "M461.9,499.8c-0.1,0-0.2-0.1-0.3-0.1c-1.1-1.3-5.7-6.1-9.7-10.3c-2.8-3-5.5-5.7-6.4-6.8 c-0.1-0.2-0.1-0.4,0.1-0.6c0.1-0.1,0.3-0.1,0.5,0c0.9,1,3.6,3.8,6.4,6.8c4.1,4.2,8.7,9.1,9.8,10.4c0.1,0.2,0.1,0.4-0.1,0.6 C462,499.8,461.9,499.8,461.9,499.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19227",
    className: "st6",
    d: "M518.9,532.3c-0.1,0-0.2,0-0.2-0.1c-5.8-4.7-9.3-21.3-7.6-26.6c0.1-0.2,0.3-0.3,0.5-0.2 c0.2,0.1,0.2,0.3,0.2,0.4c-0.8,2.5-0.5,7.8,0.9,13.2c1.5,5.9,3.9,10.6,6.4,12.6c0.2,0.1,0.2,0.4,0,0.6 C519.1,532.2,519,532.3,518.9,532.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19228",
    className: "st5",
    d: "M498.1,423.8c-0.2,0-0.4-0.1-0.5-0.3c0-0.2,0.1-0.4,0.3-0.5h0.1c8.1,0,14.6-6.5,14.6-14.6 c0-0.2,0.1-0.4,0.3-0.5s0.4,0.1,0.5,0.3v0.1C513.5,416.9,506.6,423.8,498.1,423.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19229",
    className: "st5",
    d: "M483.1,408.8c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-8.5,6.9-15.4,15.4-15.4c0.2,0,0.4,0.2,0.3,0.5 c0,0.2-0.2,0.3-0.3,0.3c-8.1,0-14.6,6.5-14.6,14.6C483.5,408.6,483.3,408.8,483.1,408.8L483.1,408.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19230",
    className: "st5",
    d: "M537.4,755.5c-0.2,0-0.4-0.2-0.4-0.4c-0.1-1.1-0.4-2.1-0.9-3.1c-0.1-0.2,0.1-0.4,0.3-0.5 s0.4,0,0.5,0.2c0.5,1,0.8,2.2,1,3.3C537.8,755.3,537.7,755.5,537.4,755.5L537.4,755.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19231",
    className: "st5",
    d: "M543.5,754.7c-0.2,0-0.4-0.1-0.4-0.3c-0.2-1.2-0.7-2.4-1.4-3.3c-0.2-0.1-0.2-0.4-0.1-0.6 c0.1-0.2,0.4-0.2,0.6-0.1l0.1,0.1c0.8,1.1,1.4,2.4,1.6,3.7C543.9,754.4,543.7,754.6,543.5,754.7L543.5,754.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19232",
    className: "st5",
    d: "M549.6,753.2c-0.2,0-0.3-0.1-0.4-0.3c-0.9-1.5-2.1-2.8-3.6-3.7c-0.2-0.1-0.2-0.4,0-0.6 c0.1-0.1,0.3-0.2,0.5-0.1c1.6,1,3,2.4,3.9,4.1c0.1,0.2,0,0.4-0.2,0.5C549.7,753.2,549.6,753.2,549.6,753.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19233",
    className: "st5",
    d: "M556.2,749.5c-0.1,0-0.2,0-0.2-0.1c-2.3-1.5-4.9-2.5-7.6-3.2c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h0.1c1.6,0.1,6.8,2.4,8,3.4c0.2,0.1,0.2,0.4,0,0.6C556.4,749.4,556.3,749.4,556.2,749.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19234",
    className: "st6",
    d: "M563.6,754.8L563.6,754.8c-0.3-0.1-0.4-0.3-0.4-0.5c0.1-0.4,2.9-8.9,7.5-11.8 c2.2-1.5,4.5-2.7,6.9-3.6c0.2,0,0.4,0.1,0.5,0.3c0,0.2-0.1,0.3-0.2,0.4c-2.4,0.9-4.6,2.1-6.8,3.5c-4.3,2.7-7.1,11.3-7.2,11.4 C564,754.7,563.8,754.8,563.6,754.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19235",
    className: "st4",
    d: "M572.8,431.4c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-3.2-2.4-2.6-9.4c0.5-6.4,3.5-9.4,8.6-14.3 c0.4-0.4,0.8-0.8,1.2-1.2c3.5-3.4,3-6.1,2.4-9.5c-0.5-2-0.6-4-0.4-6c0.8-6.5,6.1-9.4,12.5-12.2c2.4-1.1,6.1-4.3,4.4-14 c-0.8-4.4,3.4-12.1,9.3-14.7c0.4-0.2,0.9,0,1,0.4c0.2,0.4,0,0.8-0.4,1c-5.5,2.4-8.9,9.5-8.3,12.9c0.8,4.6,1.3,12.8-5.3,15.7 c-6.1,2.7-10.8,5.3-11.6,11c-0.2,1.9,0,3.7,0.4,5.5c0.6,3.4,1.3,7-2.8,10.9c-0.4,0.4-0.8,0.8-1.2,1.2c-4.9,4.8-7.6,7.4-8.1,13.3 c-0.5,6,2,8,2,8c0.3,0.3,0.4,0.8,0.1,1.1C573.3,431.3,573.1,431.4,572.8,431.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19241",
    className: "st7",
    d: "M399.6,443.2c-0.6,0-14.8-0.1-16.4-6.8c-1.3-5.8-6.7-9.3-11-9.3c-3.8,0-12.8,0-14.9-9.1 c-1.6-6.9-5-9.8-10.4-8.8c-0.4,0.1-0.8-0.2-0.9-0.7c-0.1-0.4,0.2-0.8,0.6-0.9c7.8-1.4,11,4.7,12.2,10c1.6,7,7.7,7.9,13.4,7.9 c5,0,11.1,3.9,12.6,10.5c1,4.5,11,5.5,14.8,5.5c0.4,0,0.8,0.4,0.8,0.8S400.1,443.2,399.6,443.2L399.6,443.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19242",
    className: "st7",
    d: "M433.6,383.5c-1.1,0-2.2-0.4-3.1-1.1c-1.1-1.1-1.9-2.5-2.2-4.1c-1.6,1.3-4.8,3.4-8.1,3.1 c-2.4-0.3-4.5-1.6-5.7-3.6c-1.4-1.8-1.9-4.1-1.4-6.3c0.8-3.6,4.1-6.3,5.6-7.3c-1.4-1.8-2.1-4.1-2-6.4c0.2-2.4,1.5-4.5,3.4-6 c3.2-2.7,6-2.6,7.7-2.2c2.4,0.8,4.4,2.4,5.6,4.6c1-1.8,2.5-3.2,4.3-4c2.2-0.8,4.7-0.7,6.8,0.5c2.1,0.8,3.6,2.5,4.3,4.7 c0.8,3-0.6,6.1-1.4,7.7c2.4,0.7,8,3,7.2,9.7c-0.2,2.8-2,5.3-4.6,6.3c-3.2,1-6.6,0.5-9.3-1.4c-0.8,1.9-2.7,5.6-6.6,5.9 C433.9,383.5,433.8,383.5,433.6,383.5 M429.7,376.7c0,0.1,0.2,3.1,1.9,4.5c0.7,0.6,1.5,0.8,2.4,0.7c4.1-0.3,5.6-5.8,5.6-5.8 c0.1-0.4,0.5-0.7,1-0.6c0.1,0,0.2,0.1,0.3,0.2c2.4,2,5.6,2.7,8.6,1.8c2.1-0.8,3.5-2.8,3.6-5c0.8-7-6.6-8.1-7-8.2 s-0.7-0.5-0.7-0.9c0-0.1,0.1-0.2,0.1-0.3c0,0,2.7-4,1.8-7.3c-0.5-1.7-1.8-3-3.4-3.6c-1.7-0.9-3.7-1.1-5.5-0.5 c-2.9,1.2-4.2,4.6-4.2,4.6c-0.1,0.3-0.4,0.5-0.7,0.5l0,0c-0.3,0-0.6-0.2-0.7-0.5c-0.9-2.4-2.9-4.3-5.3-5.1 c-2-0.6-4.2,0.1-6.3,1.9c-1.6,1.2-2.6,2.9-2.8,4.8c0,2.2,0.7,4.3,2.1,5.9c0.3,0.3,0.3,0.8-0.1,1.1l-0.1,0.1c0,0-4.8,2.8-5.6,6.8 c-0.4,1.8,0.1,3.6,1.2,5c1,1.6,2.7,2.7,4.6,3c4,0.4,7.9-3.5,8-3.6c0.3-0.3,0.8-0.3,1.1,0C429.6,376.3,429.7,376.5,429.7,376.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlMagnifyingGlass);
export default __webpack_public_path__ + "static/media/girl_magnifying_glass.d7906dc01852243da2a0ff8418cc22c3.svg";
export { ForwardRef as ReactComponent };